import React, { Fragment } from 'react';

import HTMLHeader from '../../mainPanel/HTMLHeader';
import CodeEditor from '../../../ui/components/codeEditor/CodeEditor';
import { getPermaLink } from '../../../helpers/generators';


export default ({ snippet }) => (
    <Fragment>
        <HTMLHeader title={`${snippet.title} - Embed`} />
        <CodeEditor
            title={snippet.title}
            code={snippet.code}
            language={snippet.Language.alias}
            editable={false}
            wrap={false}
            showCopyBtn={false}
            noMargin
            watermark
            permalink={getPermaLink(snippet)}
        />
    </Fragment>
);
